// ! Some of the code here are for visuals only ra jud TT

import React, { useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { payBookingPackage, payMultiplePayment } from "../../utilities/api_calls/paymentApi";
import { numberFormat, refreshPage } from "../../utilities/common";
import { useNavigate } from "react-router-dom";

// css
import '../common.css';
import './payment_modal.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function CustomerPaymentModal({ 
  showVar, 
  showVarSetter, 
  cartPayment, 
  modalData, 
  paymentType, 
  handlePaymentChange, 
  type, 
  payDetails, 
  selectedBooking, 
  existingSummary, 
  balanceDetails, 
  balance, 
  subTotal, 
  discount, 
  grandTotal, 
  payExit, 
  giftCerts, 
  giftCertDeets,
  isPackage, 
  isGiftCert,
  setTotalBalance,
}) {
  // Card Payment Details
  const [isLoading, setIsLoading] = useState(false)
  const [paymentDeets, setPaymentDeets] = useState("cash");
  const [savedPaymentData, setSavedPaymentData] = useState([]);
  const handlePaymentDetailReset = () => setPaymentDeets("cash")
  const [click, setClick] = useState(false);
  const navigate = useNavigate()
  
  const total_paid_amount = savedPaymentData ? savedPaymentData.reduce((sum, item) => sum + parseFloat(item.amount), 0) : 0
  const total_balance = parseFloat(grandTotal || 0) - parseFloat(total_paid_amount || 0);

  React.useEffect(() => {
    if (total_balance) {
      setTotalBalance(total_balance)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total_balance]);

  function checkItemTypes() {
    var allowBalance = true;

    existingSummary.forEach((item) => {
      if (item.type !== "package") {
        allowBalance = false;
      }
    })

    return allowBalance;
  }

  async function payBooking() {
    var validation = true;
    var allowBalance = checkItemTypes();

    if (paymentType === "") {
      toast.error("Please choose payment type.")
      validation = false;

    } else if (parseFloat(payDetails.amount) > grandTotal) {
      toast.error("Amount exceeds grand total.")
      validation = false;

    } else if (parseFloat(payDetails.amount) < grandTotal && allowBalance === false) {
      toast.error("Insufficient amount.");
      validation = false;

      // if(allowBalance === false) {
      //   toast.info("Downpayments are only allowed for packages.")
      // }

    } else if (validation && click === false) {
      setClick(true);
      const response = await payBookingPackage(paymentDeets, payDetails, selectedBooking.booking_id)
      if(response.data){
        toast.success("Successfully Paid!");
        setTimeout(() => navigate(-1), 1000);
      } else {
        let res = response.error.data.messages
        toast.error(res.error);
      }
      setClick(false);
    }
  }

  async function payPurchase() {
    setIsLoading(true)
    if (click === false) {
      if(total_balance === 0){
        setClick(true);
        const response = await payMultiplePayment(savedPaymentData, selectedBooking, discount);
        if (response.data.data.status === 200 || response.data.data.status === 201) {
          toast.success("Successfully Paid!");
          setTimeout(function () {
            refreshPage();
          }, 3000);
        }
        if (response.data.status === 400 || response.data.data.status === 400) {
          toast.error("Payment Unsuccessful!");
        }
      } else {
        setClick(false);
        toast.error("No Overpayment!")
      }
    }
    setIsLoading(false)
  }

  function savePayment(){
    setIsLoading(true)
    if(paymentDeets === "gift_certificate"){
      const gc_data = giftCertDeets[0];
      if(gc_data.amount > total_balance){
        setSavedPaymentData(prevItems => [...prevItems, {amount: total_balance, gc_id: gc_data.id, payment_method: paymentDeets}]);
      } else {
        setSavedPaymentData(prevItems => [...prevItems, {amount: gc_data.amount, gc_id: gc_data.id, payment_method: paymentDeets}]);
      }
    } else {
      setSavedPaymentData(prevItems => [...prevItems, {...payDetails, payment_method: paymentDeets}]);
    }
    handlePaymentChange(null)
    setPaymentDeets("cash")
    setIsLoading(false)
  }

  const deleteItemAtIndex = (indexToDelete) => {
    setSavedPaymentData(prevItems => prevItems.filter((_, index) => index !== indexToDelete));
  };

  React.useEffect(() => {
    if (showVar) {
      toast.info("Downpayments are only allowed for packages.", { autoClose: false });
    } else {
      toast.dismiss();
    }
  }, [showVar]);

  const cashPaymentDetail = () => {
    return (
      <Col className="nc-modal-custom-row">
        <Col className="fw-bold">amount</Col>
        <Col className="">
          <Form.Control 
            type="number" 
            onWheel={(e) => e.target.blur()}
            min="0.01" 
            step="0.01" 
            name="amount" 
            disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0}
            placeholder="Enter amount" 
            className="nc-modal-custom-input payment-input-size-custom mb-1" 
            onChange={(e) => handlePaymentChange(e)} 
            value={payDetails.amount >= 0 ? payDetails.amount : ''}          
          />
        </Col>
      </Col>
    )
  }

  const cardPaymentDetail = () => {
    return (
      <div>
        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">amount</Col>
          <Col className="">
            <Form.Control 
              type="number" 
              onWheel={(e) => e.target.blur()}
              min="0.01" 
              step="0.01" 
              disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0}
              name="amount" 
              placeholder="Enter amount" 
              className="nc-modal-custom-input payment-input-size-custom mb-1" 
              onChange={(e) => handlePaymentChange(e)} 
              value={payDetails.amount >= 0 ? payDetails.amount : ''} 
            />
          </Col>
        </Col>
        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">card details</Col>
          <Col className="">
            <Form.Control 
              type="text" 
              disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0}
              name="card_type" 
              placeholder="Card Type" 
              className="nc-modal-custom-input payment-input-size-custom mb-1" 
              onChange={(e) => handlePaymentChange(e)} 
              value={payDetails.card_type}
            />
          </Col>
          <Col className="">
            <Form.Control 
              type="text" 
              disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0}
              name="acc_no" 
              placeholder="Account Number" 
              className="nc-modal-custom-input payment-input-size-custom mb-1" 
              onChange={(e) => handlePaymentChange(e)} 
              value={payDetails.acc_no}
            />
          </Col>
          <Col className="d-flex flex-row ">
            <Form.Control 
              type="date" 
              disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0}
              name="card_expiry" 
              className="nc-modal-custom-input payment-input-size-custom" 
              onChange={(e) => handlePaymentChange(e)} 
              value={payDetails.card_expiry}
            />
            <Form.Control type="text" name="cvc_cvv" placeholder="CVV/CVC" className="nc-modal-custom-input payment-input-size-custom ms-1" onChange={(e) => handlePaymentChange(e)} value={payDetails.cvc_cvv}/>
          </Col>
        </Col>
      </div>
    )
  }
  // eslint-disable-next-line
  const chequePaymentDetail = () => {
    return (
      <div>
        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">amount</Col>
          <Col className="">
            <Form.Control type="number" onWheel={(e) => e.target.blur()} min="0.01" step="0.01" name="cheque-amount" placeholder="Enter amount" className="nc-modal-custom-input payment-input-size-custom mb-1" />
          </Col>
        </Col>
        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">bank name</Col>
          <Col className="">
            <Form.Control type="text" name="bank_name" placeholder="Enter bank name" className="nc-modal-custom-input payment-input-size-custom mb-1" />
          </Col>
        </Col>
        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">cheque number</Col>
          <Col className="">
            <Form.Control type="text" name="cheque_number" placeholder="Enter cheque number" className="nc-modal-custom-input payment-input-size-custom mb-1" />
          </Col>
        </Col>
        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">cheque date</Col>
          <Col className="">
            <Form.Control type="date" name="cheque_date" className="nc-modal-custom-input payment-input-size-custom mb-1" />
          </Col>
        </Col>
      </div>
    )
  }

  const bankPaymentDetail = () => {
    return (
      <div>

        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">amount</Col>
          <Col className="">
            <Form.Control disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0} onWheel={(e) => e.target.blur()} type="number" min="0.01" step="0.01" name="amount" placeholder="Enter amount" className="nc-modal-custom-input payment-input-size-custom mb-1" onChange={(e) => handlePaymentChange(e)} value={payDetails.amount >= 0 ? payDetails.amount : ''} />
          </Col>
        </Col>
        {/* 
        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">bank name</Col>
          <Col className="">
            <Form.Control type="text" name="bank_name" placeholder="Enter bank name" className="nc-modal-custom-input payment-input-size-custom mb-1"/>
          </Col>
        </Col> */}

        <Col>
          <Col className="fw-bold">account details</Col>
          <Row className="account-detail-custom">
            <Col xs={4} className="fw-bold ms-3">Account Name</Col>
            :
            <Col>Lovely Shane Gucor</Col>
          </Row>
          <Row className="account-detail-custom">
            <Col xs={4} className="fw-bold ms-3">Card Number</Col>
            :
            <Col>12345678010</Col>
          </Row>
        </Col>

        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">proof of payment</Col>
          <Col className="">
            <Form.Control disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0} type="text" name="proof" placeholder="Proof of Payment" className="nc-modal-custom-input payment-input-size-custom mb-1" onChange={(e) => handlePaymentChange(e)} value={payDetails.proof}/>
          </Col>
        </Col>
      </div>
    )
  }

  const onlinePaymentDetail = () => {
    return (
      <div>

        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">amount</Col>
          <Col>
            <Form.Control disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0} onWheel={(e) => e.target.blur()} type="number" min="0.01" step="0.01" name="amount" placeholder="Enter amount" className="nc-modal-custom-input payment-input-size-custom mb-1" onChange={(e) => handlePaymentChange(e)}value={payDetails.amount >= 0 ? payDetails.amount : ''}/>
          </Col>
        </Col>

        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">payment channels</Col>
          <Col className="">
            <Form.Control disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0} type="text" className="nc-modal-custom-input" name="type" onChange={(e) => handlePaymentChange(e)} value={payDetails.type}/>
            {/* <option value="gcash">GCash</option>
              <option value="paymaya">PayMaya</option>
            </Form.Select> */}
          </Col>
        </Col>

        {/* <Col>
          <Col className="fw-bold">account details</Col>
          <Row className="account-detail-custom">
            <Col xs={4} className="fw-bold ms-3">Account Name</Col>
            :
            <Col>Lovely Shane Gucor</Col>
          </Row>
          <Row className="account-detail-custom">
            <Col xs={4} className="fw-bold ms-3">Card Number</Col>
            :
            <Col>12345678010</Col>
          </Row>
        </Col> */}

        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">proof of payment</Col>
          <Col className="">
            <Form.Control disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0} type="text" name="proof" placeholder="Proof of Payment" className="nc-modal-custom-input payment-input-size-custom mb-1" onChange={(e) => handlePaymentChange(e)}  value={payDetails.proof}/>
          </Col>
        </Col>
      </div>
    )
  }

  const giftCertificatePaymentDetail = () => {
    return (
      <>
        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">Search code</Col>
          <Col className="">
            <Form.Control type="text" name="code" placeholder="Enter gift certificate code" className="nc-modal-custom-input payment-input-size-custom mb-1"
              value={payDetails.code}
              onChange={(e) => handlePaymentChange(e)}
              disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0}
            />
          </Col>
          <Col>
            <Col className="fw-bold">SELECT AVAILABLE GIFT CERTIFICATE</Col>
            <select disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0} name="selected_code" onChange={(e) => handlePaymentChange(e)}>
              <option value="" hidden>--SELECT--</option>
              {giftCerts.length !== 0 ? giftCerts.map((data, index) => {
                return <option value={data.ID}>{data.NAME + " - " + data.CODE}</option>
              }) : <option disabled>No GCs available</option>}
            </select>
          </Col>
        </Col>

        <Col className="nc-modal-custom-row">
          <Col className="fw-bold">gift certificate details</Col>
          {/* must be dynamic depending sa GCS code */}
          {giftCertDeets.length !== 0 && (
            <div>
              <p className="account-detail-custom ms-3 fw-normal">{giftCertDeets[0].name}</p>
              <p className="account-detail-custom ms-3 fw-normal">{"DETAILS: " + giftCertDeets[0].details}</p>
            </div>
          )}
        </Col>


      </>
    )
  }

  const shoppingCart = [];


  function updateCart() {
    let id, cartItemObj;
    var totalCost, finalCost = "";

    if (paymentType === 'booking') {
      cartPayment.forEach((cartItem) => {
        // services
        if (cartItem[0] === 's') {
          id = parseInt(cartItem.substring(2));
          cartItemObj = modalData[0].find(srv => srv.id === id);
          shoppingCart.push(cartItemObj);
          totalCost += cartItemObj.price;
          // packages
        } else if (cartItem[0] === 'p') {
          id = parseInt(cartItem.substring(2));
          cartItemObj = modalData[1].find(pck => pck.id === id);
          shoppingCart.push(cartItemObj);
          totalCost += cartItemObj.price;
        }
      })
    }
    else if (paymentType === "customer") { // sample temporary
      cartItemObj = cartPayment[0];
      shoppingCart.push(cartItemObj);
      totalCost += cartItemObj.price;
    }

    if (shoppingCart.length || totalCost >= discount) {
      // eslint-disable-next-line
      finalCost = totalCost - discount;
    }
  }

  return (
    <>
      <Modal 
        show={showVar} 
        onShow={updateCart()} 
        onHide={() => { showVarSetter(); handlePaymentDetailReset() }} 
        size="xl" 
        className="custom-modal-style" 
        centered
        backdrop="static"
        keyboard={false}
      >
        {/* <ToastContainer /> */}
        {/* <Modal.Header className="custom-modal-header d-flex justify-content-end" closeButton></Modal.Header> */}

        <Modal.Body className="px-5 py-1 d-flex flex-row">

          <Container className="px-0">
            <Row className="nc-modal-custom-row ml-0 pl-0">
              <span className="custom-modal-body-subtitle pl-0">summary</span>
            </Row>
            {/* <Row className="pb-3 purchlist-group-custom">

              {existingSummary && existingSummary.map((data, index) => {

                return <Row className='nc-modal-custom-row'>
                  <Col xs={1}>{data.quantity}</Col>
                  <Col xs={6} className="fw-bold">{data.name}</Col>
                  <Col xs={5} className="fw-bold" align="right">P {numberFormat(data.price || data.total_price) || ""}</Col>
                </Row>
              })}

            </Row> */}
            <Row className="pb-3 nc-modal-custom-row">
              {existingSummary && existingSummary.map((data) => (
                <Row>
                  <Col xs={8} className="fw-bold">{`${data.quantity} ${data.name}`}</Col>
                  <Col xs={4} align="right">P {data?.total_price ? numberFormat(data?.total_price) : '0.00'}</Col>
                </Row>
              ))}
              <Row className="mt-4">
                <Col xs={7} className="fw-bold">total cost</Col>
                <Col align="right">P {subTotal ? numberFormat(subTotal) : "0.00"}</Col>
              </Row>
              <Row>
                <Col xs={7} className="fw-bold red">discount</Col>
                <Col align="right" className="red">P {discount ? numberFormat(discount) : "0.00"}</Col>
              </Row>
              <Row>
                <Col xs={7} className="fw-bold">final cost</Col>
                <Col align="right">P {grandTotal ? numberFormat(grandTotal) : '0.00'}</Col>
              </Row>
            </Row>

            
            <Row className="pb-3 nc-modal-custom-row">
              {
                savedPaymentData && savedPaymentData.map((data, index) => (
                  <Row className="mb-2">
                    <Col>
                      <FontAwesomeIcon
                        className="icon fa-xl align-self-center edit-details-icon"
                        icon="fa-solid fa-trash"
                        onClick={() => deleteItemAtIndex(index)}
                      />
                    </Col>
                    <Col className="fw-bold">{data.payment_method && data.payment_method.replace(/_/g, ' ')}</Col>
                    <Col xs={9} align="right">P {data?.amount ? numberFormat(data?.amount) : '0.00'}</Col>
                  </Row>
                ))
              }
            </Row>
            {
              !isPackage && (
                <>
                  <Row className="pb-3 nc-modal-custom-row">
                    <Row>
                      <Col xs={7} className="fw-bold">Paid Amount</Col>
                      <Col align="right">P {total_paid_amount ? numberFormat(total_paid_amount) : '0.00'}</Col>
                    </Row>
                    <Row>
                      <Col xs={7} className="fw-bold">Balance</Col>
                      <Col align="right">P {total_balance ? numberFormat(total_balance) : '0.00'}</Col>
                    </Row>
                  </Row>
                </>
              )
            }
          </Container>

          <div className="custom-modal-vertline-border mx-3"></div>

          <Container>

            <Row className="nc-modal-custom-row p-0">
              <span className="custom-modal-body-subtitle p-0">payment</span>
            </Row>

            <Col className="nc-modal-custom-row">
              <Col className="fw-bold">payment method</Col>
              <Form.Select disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0} className="nc-modal-custom-input" name="payment_type" value={paymentDeets} onChange={(e) => { setPaymentDeets(e.target.value); }}>
                <option value="" selected hidden>--SELECT--</option>
                <option value="cash">Cash</option>
                {/* <option value="cheque">Cheque</option> */}
                <option value="card">Credit/Debit Card</option>
                <option value="online">Online Payment Channel</option>
                <option value="bank_transfer">Bank Transfer</option>
                {!isGiftCert && <option value="gift_certificate">Gift Certificate</option>}
              </Form.Select>
            </Col>

            {paymentDeets === "cash" && cashPaymentDetail()}
            {/* {paymentDeets === "cheque" && chequePaymentDetail()} */}
            {paymentDeets === "card" && cardPaymentDetail()}
            {paymentDeets === "online" && onlinePaymentDetail()}
            {paymentDeets === "bank_transfer" && bankPaymentDetail()}
            {paymentDeets === "gift_certificate" && giftCertificatePaymentDetail()}

            <Col className="nc-modal-custom-row">
              <Col className="fw-bold">remarks</Col>
              <Form.Control disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0} as="textarea" className="nc-modal-custom-input" name="remarks" onChange={(e) => { handlePaymentChange(e) }} rows={1}  value={payDetails.remarks}/>
            </Col>
            {paymentType === 'existing-booking' && <Col className="nc-modal-custom-row mt-0">
              <Col className="fw-bold">OR NO.</Col>
              <Form.Control disabled={parseFloat(grandTotal) === 0.00 ? false : total_balance <= 0} type="text" name="or_no" className="nc-modal-custom-input" onChange={(e) => handlePaymentChange(e)}  value={payDetails.or_no}/>
            </Col>}
          </Container>

        </Modal.Body>

        <Modal.Footer className="border-0 px-5">
          <div className="d-flex flex-row justify-content-between">
            <div className="btn-conf-wrapper ms-auto">
              {click === true ? (
                  <div className="d-flex justify-content-center">
                    <div className="btn-conf-wrapper ms-auto">
                      <Button type="submit" className="px-5 pb-1 mb-2">
                        <ReactLoading type="spinningBubbles" color="#d4271c" height={25} width={20} />
                      </Button>
                    </div>
                  </div>
                ) : (
                 <>
                    {
                      isPackage  ? (
                        <Button 
                          type="submit" 
                          className="px-5 pb-1 mb-2" 
                          onClick={() => payBooking()}
                        >
                          Pay Package
                        </Button>
                      ) : (
                        <>
                          {
                            parseFloat(grandTotal) === 0.00 ? (
                              <>
                                {
                                  savedPaymentData.length > 0 ? (
                                    <Button 
                                      type="submit" 
                                      className="px-5 pb-1 mb-2" 
                                      onClick={payPurchase}
                                      disabled={parseFloat(total_balance) !== 0.00 || isLoading}
                                    >
                                      
                                        Pay 
                                    </Button>
                                  ):(
                                    <Button 
                                      type="submit" 
                                      className="px-5 pb-1 mb-2" 
                                      onClick={savePayment}
                                      disabled={
                                        (paymentDeets !== "gift_certificate" && grandTotal !== 0) &&
                                        (
                                          !payDetails ||
                                          Object.keys(payDetails).length === 0 ||
                                          payDetails.amount === '' ||
                                          parseInt(payDetails.amount) < 0
                                        )
                                      }
                                    >
                                      Save Payment
                                    </Button>
                                  )
                                }
                              </>
                            ) : (
                              <>
                                {
                                  total_balance === 0 ? (
                                    <Button 
                                      type="submit" 
                                      className="px-5 pb-1 mb-2" 
                                      onClick={payPurchase}
                                      disabled={isLoading}
                                    >
                                        Pay 
                                    </Button>
                                  ) : (
                                    <Button 
                                      type="submit" 
                                      className="px-5 pb-1 mb-2" 
                                      onClick={savePayment}
                                      disabled={
                                        (paymentDeets !== "gift_certificate" && grandTotal !== 0) &&
                                        (
                                          !payDetails ||
                                          Object.keys(payDetails).length === 0 ||
                                          payDetails.amount === '' ||
                                          parseInt(payDetails.amount) < 0
                                        )
                                      }
                                    >
                                      Save Payment
                                    </Button>
                                  )
                                }
                              </>
                            )
                          }
                        </>
                      )
                    }
                 </>
                 
                )
              }
             
            </div>
          </div>
        </Modal.Footer>

      </Modal>
    </>
  );
}

export default CustomerPaymentModal;